import { PayerAccount, WireTransfer } from "../types/WireTransfer";

export const WIRETRANSFER_PAYER_ACCOUNTS = [
  {
    value: PayerAccount.legalbirdMain,
    label: "Legalbird GmbH Hauptkonto",
  },
  {
    value: PayerAccount.legalbirdRevenue,
    label: "Legalbird GmbH Umsatzkonto",
  },
  {
    value: PayerAccount.lbra,
    label: "LBRA GmbH Konto",
  },
];

export function getWiretransferDisplayStatus(wiretransfer: WireTransfer) {
  if (!!wiretransfer.paymentRun) {
    return "Im Zahllauf";
  }
  if (!!wiretransfer.factualCorrectDate && !wiretransfer.calculativeCorrectDate) {
    return "Sachlich geprüft";
  }
  if (!!wiretransfer.factualCorrectDate && !!wiretransfer.calculativeCorrectDate) {
    return "Rechnerisch geprüft";
  }
  return "Erstellt";
}

export function getWiretransferPayerAccountLabel(payerAccount: WireTransfer["payerAccount"]) {
  const option = WIRETRANSFER_PAYER_ACCOUNTS.find((account) => account.value === payerAccount);

  return option?.label || "-";
}
